import { Typography } from 'antd'
import DashboardView from 'component/Client/DashboardView'

const { Title } = Typography

const Dashboard = () => {
	return (
		<>
			<Title level={2}>Dashboard</Title>
			<DashboardView clientId={undefined} />
		</>
	)
}

export default Dashboard
